@if (
  (permissionService.canLogistDevicesUpdateLocation$ | async) &&
  isLocationDeprecated
) {
  <button
    tuiButton
    type="button"
    size="s"
    class="mt-1"
    (click)="updateLocation$.next()"
  >
    {{ 'request_form.devices.device.location_updater.set_button' | translate }}
  </button>
}
